import { render } from "./EventModal.vue?vue&type=template&id=74985175&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"

import "./EventModal.vue?vue&type=style&index=0&id=74985175&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74985175"]])

export default __exports__